module.exports = __webpack_public_path__ + "img/bianjie1.bb399d16.png";